import React, { Component } from 'react';
import clsx from 'clsx';
// import PropTypes from 'prop-types';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import { Field, reduxForm } from 'redux-form';
import { Grid, Button } from '@material-ui/core';
import RenderTextFieldRedux from './../Complements/RenderTextFieldRedux';

const validate = values => {
    const error  = {}
    if (!values.username) {
        error.cedule = "El email es requerido"
    }
    if (!values.password) {
        error.cellphone = "La contraseña es un campo obligatorio"
    }
    return error
}
class UserRegisterSecondForm extends Component {
    state = {
    }
    render() {
        const { classes, handleSubmit,  valid, submitting, handleBack, activeStep } = this.props;
        return (
            <React.Fragment>
                <form  onSubmit={ handleSubmit }>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                name="username"
                                id="username"
                                required
                                className={clsx(classes.margin, classes.textField)}
                                component={ RenderTextFieldRedux }
                                label="Nombre de usuario"
                                type="text"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                name="password"
                                id="password"
                                required
                                //disabled
                                type="password"
                                className={clsx(classes.margin, classes.textField)}
                                component={ RenderTextFieldRedux }
                                label="Contraseña"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6} md={6} lg={6}>
                            <Button variant="contained" onClick = {  handleBack } disabled={activeStep === 0}>
                                Atras
                            </Button>
                        </Grid>
                        <Grid item xs={6} md={6} lg={6}>
                            <Button variant="contained" type="submit"
                                disabled={!valid || submitting}
                                color="primary" >
                                Siguiente
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </React.Fragment>
        );
    }
}

UserRegisterSecondForm.propTypes = {

};

const UserRegisterSecondReduxForm = reduxForm(
    {
      form: 'UserRegisterSecondForm',
      validate
    }
)(UserRegisterSecondForm)

// export default UserRegisterSecondForm;
export default setPropsAsInitial(UserRegisterSecondReduxForm)